import React, { useRef } from 'react';
import useFullscreen from '../hooks/useFullscreen';
import Q2 from '../Assets/Q2.mp4';

function Award() {
    const pageRef = useRef(null);
    const { isFullscreen, toggleFullscreen } = useFullscreen(pageRef);
    return (
        <div
            ref={pageRef}
            className="office413-video-page"
            onDoubleClick={toggleFullscreen}
        >
            <video
                className="office413-video-frame"
                src={Q2}
                title="413 Office video"
                autoPlay
                muted
                loop
                playsInline
                controls={false}
            />
            <button
                type="button"
                className="fullscreen-toggle-button"
                onClick={toggleFullscreen}
                aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
            >
                {isFullscreen ? 'EX' : 'FS'}
            </button>
            <style>{`
                .office413-video-page {
                  position: fixed;
                  inset: 0;
                  background: #000;
                  overflow: hidden;
                }
        
                .office413-video-frame {
                  position: absolute;
                  inset: 0;
                  width: 100%;
                  height: 100%;
                  border: 0;
                  object-fit: cover;
                }

                .fullscreen-toggle-button {
                  position: absolute;
                  top: 12px;
                  right: 12px;
                  z-index: 3;
                  width: 34px;
                  height: 34px;
                  border: 1px solid rgba(255, 255, 255, 0.75);
                  border-radius: 6px;
                  background: rgba(0, 0, 0, 0.45);
                  color: #fff;
                  font-size: 11px;
                  font-weight: 700;
                  letter-spacing: 0.5px;
                  cursor: pointer;
                  padding: 0;
                }
              `}</style>
        </div>
    )
}

export default Award
